angular
	.module 'App.Component'
	.component 'promotionProductCategories',
		{
			templateUrl: '@component/promotion-product-categories/promotion-product-categories.view.html'
			controller: 'PromotionProductCategoriesController'
			controllerAs: 'promotionProductCategories'
			bindings:
				promotionProductCategories: '<'
				showPriceField: '<?'
				onPromotionProductCategoriesChange: '&'
		}

class PromotionProductCategoriesController extends AbstractController
	@registerController()
	@inject 'ProductCategoryRepository'

	initialize: ->
		@attributesMap =
			id: 'id'
			name: 'path'

		@showPriceField ?= false

		if _.isEmpty @promotionProductCategories
			@promotionProductCategories = []

			@productCategories = []

	addProductCategory: (productCategory) ->
		existingIds = _.pluck @promotionProductCategories, 'id'

		if existingIds.includes(productCategory.id)
			return

		@promotionProductCategories.push(productCategory)
		@productCategories = []

		@onPromotionProductCategoriesChange({changedPromotionProductCategories: @promotionProductCategories})

	removeProductCategory: (productCategoryToRemove) ->
		@promotionProductCategories = _.reject(@promotionProductCategories, {id: productCategoryToRemove.id})

		@onPromotionProductCategoriesChange({changedPromotionProductCategories: @promotionProductCategories})

	searchProductCategories: (categoryName) ->
		if _.isEmpty categoryName
			@productCategories = []

			return

		query = @ProductCategoryRepository.createQuery()

		query.criteria 'name', 'LIKE', categoryName
		query.criteria('exclude_from_discounts', 'IS', 'NULL').or('exclude_from_discounts', '=', '0')

		@ProductCategoryRepository
			.getEntities query
			.then (response) =>
				@productCategories = response
